module.exports = __webpack_public_path__ + "img/52002760_L.28e96b00.png";